const colors = {
  primary: "#2b6cb0",
  secondary: "#9cf2ff",
  alt: "rgba(232, 238, 244, 1)"
};

export default colors;
